module.exports = __webpack_public_path__ + "img/WF.3ee6e5ad.svg";